import { fireErrorAnalytics as fireJiraErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { AnalyticsEventPayload, UIAnalyticsEvent } from '@atlaskit/analytics-next';
import {
	fireTrackAnalytics,
	type AnalyticsAttributes,
} from '@atlassian/jira-product-analytics-bridge';
import type { CrossJoinIntegraton } from '../../common/types.tsx';

export type CreateAnalyticsEvent = (payload: AnalyticsEventPayload) => UIAnalyticsEvent;

export const fireErrorAnalytics = (
	id: string,
	error: Error,
	attributes: AnalyticsAttributes = {},
): Promise<void> =>
	fireJiraErrorAnalytics({
		meta: {
			id,
			packageName: 'jiraCrossJoinNudges',
			teamName: 'puma',
		},
		attributes,
		error,
		sendToPrivacyUnsafeSplunk: true,
	});

export const fireSiteOptedOutAnalytics = (
	createAnalyticsEvent: CreateAnalyticsEvent,
	integration: CrossJoinIntegraton,
): void => {
	fireTrackAnalytics(createAnalyticsEvent({}), 'eligibility checked', {
		flagKey: 'NON_CONTEXTUAL_CJNS',
		ineligibilityReason: 'SITE_OPTED_OUT',
		integration,
	});
};

export const fireMsrNotRecommendedAnalytics = (
	createAnalyticsEvent: CreateAnalyticsEvent,
	integration: CrossJoinIntegraton,
	nudgeId: string,
): void => {
	fireTrackAnalytics(createAnalyticsEvent({}), 'eligibility checked', {
		flagKey: 'NON_CONTEXTUAL_CJNS',
		ineligibilityReason: 'MSR_NOT_RECOMMENDED',
		integration,
		nudgeId,
	});
};
